import {
  BASE_URL
} from '../libs/tool.js'
const baseUrl = BASE_URL;
const baseURL = BASE_URL;
const baseAPI = '/api';
const api_auth = baseUrl + '/auth.json';

export * from './apiCall.js';

/*集成接口*/
// 区域树
const api_getAreaTypeTree = baseURL + '/smart-care/api/sys/getAreaTypeTree';
// 新增区域
const api_addAreaType = baseURL + '/smart-care/api/sys/addAreaType';
// 区域列表
const api_getAreaTypeList = baseURL + '/smart-care/api/sys/getAreaTypeList';
// 区域列表（下拉选择列表）
const api_getSimpleAreaTypeList = baseURL + '/smart-care/api/sys/getSimpleAreaTypeList';
// 删除区域
const api_deleteAreaType = baseURL + '/smart-care/api/sys/deleteAreaType';
// 编辑区域
const api_editAreaType = baseURL + '/smart-care/api/sys/editAreaType';
// 实时监测列表（房屋卡片）
const api_getRealtimeMonitorList = baseURL + '/smart-care/api/sys/getRealtimeMonitorList';
// 新增房屋
const api_addHouse = baseURL + '/smart-care/api/sys/addHouse';
// 编辑房屋
const api_editHouse = baseURL + '/smart-care/api/sys/editHouse';
// 删除房屋
const api_deleteHouse = baseURL + '/smart-care/api/sys/deleteHouse';
// 实时监测详情（房屋详情）
const api_getRealtimeMonitorDetail = baseURL + '/smart-care/api/sys/getRealtimeMonitorDetail';
// 变更房屋所属区域
const api_changeHouseAreaType = baseURL + '/smart-care/api/sys/changeHouseAreaType';
// 新增居家安全设备
const api_addHomeDevice = baseURL + '/smart-care/api/sys/addHomeDevice';
// 居家安全设备列表
const api_listHomeDevice = baseURL + '/smart-care/api/sys/listHomeDevice';
// 房屋列表
const api_listHouse = baseURL + '/smart-care/api/sys/listHouse';
// 绑定居家安全设备
const api_bindingHomeDevice = baseURL + '/smart-care/api/sys/bindingHomeDevice';
// 解绑居家安全设备
const api_unbindHomeDevice = baseURL + '/smart-care/api/sys/unbindHomeDevice';
// 删除居家安全设备
const api_deleteHomeDevice = baseURL + '/smart-care/api/sys/deleteHomeDevice';
// 修改预警功能状态
const api_setHomeDeviceWarning = baseURL + '/smart-care/api/sys/setHomeDeviceWarningFunction';
const setDeviceWarningFunction = baseURL + '/smart-care/api/sys/setDeviceWarningFunction';
const syncWarningUser = baseURL + '/smart-care/api/sys/syncWarningUser';
// 居家安全设备详情
const api_getHomeDeviceDetail = baseURL + '/smart-care/api/sys/getHomeDeviceDetail';

// 居家安全修改门磁预警配置
const api_editHA03WarningSetting = baseURL + '/smart-care/api/sys/editHA03WarningSetting';

// 居家安全修改红外预警配置
const editHA05WarningSetting = baseURL + '/smart-care/api/sys/editHA05WarningSetting';


const editHomeDeviceSosContact = baseURL + '/smart-care/api/sys/editHomeDeviceSosContact';

// 433修改门磁预警配置
const editTerminalWarningSetting = baseURL + '/smart-care/api/sys/editTerminalWarningSetting';

// 433修改红外预警配置
const editTerminalInfraredSetting = baseURL + '/smart-care/api/sys/editTerminalInfraredSetting';

// 编辑居家安全设备信息
const editHomeDevice = baseURL + '/smart-care/api/sys/editHomeDevice';

// 居家安全修改门磁门磁状态列表
const api_listDoorStatusData = baseURL + '/smart-care/api/sys/listDoorStatusData';

// 守护模式批量设置
const api_editHomeDeviceInfrared = baseURL + '/smart-care/api/sys/editHomeDeviceInfrared';

// 会员列表
// const api_listUser = baseURL + '/smart-care/api/sys/listUser';
// 用户绑定房屋
const api_bindingUserHouse = baseURL + '/smart-care/api/sys/bindingUserHouse';
// 用户解绑房屋
const api_unbindUserHouse = baseURL + '/smart-care/api/sys/unbindUserHouse';
// 睡眠带详情
const api_getSleepBandDetail = baseURL + '/smart-care/api/sys/getSleepBandDetail.do';
// 批量导入睡眠带（居家养老模式）
const api_importHomeSleepBand = baseURL + '/smart-care/api/sys/importHomeSleepBand.do';


/*服务派单接口*/
// 服务类型列表
const api_getServiceTypeList = baseURL + '/aiqiangua-service-dispatch/getServiceTypeList';
// 编辑 - 服务类型
const api_editServiceType = baseURL + '/aiqiangua-service-dispatch/editServiceType';
// 新增 - 服务类型
const api_addServiceType = baseURL + '/aiqiangua-service-dispatch/addServiceType';
// 删除 - 服务类型
const api_deleteServiceType = baseURL + '/aiqiangua-service-dispatch/deleteServiceType';
// 服务类型下拉列表项
const api_getServiceTypeItem = baseURL + '/aiqiangua-service-dispatch/getServiceTypeItem';
// 列表 - 服务机构
const api_getServiceOrganizationList = baseURL + '/aiqiangua-service-dispatch/getServiceOrganizationList';
// 新增 - 服务机构
const api_addServiceOrganization = baseURL + '/aiqiangua-service-dispatch/addServiceOrganization';
// 编辑 - 服务机构
const api_editServiceOrganization = baseURL + '/aiqiangua-service-dispatch/editServiceOrganization';
// 删除 - 服务机构
const api_deleteServiceOrganization = baseURL + '/aiqiangua-service-dispatch/deleteServiceOrganization';
// 服务机构下拉列表项
const api_getServiceOrganizationItem = baseURL + '/aiqiangua-service-dispatch/getServiceOrganizationItem';
// 列表 - 服务清单
const api_getServiceList = baseURL + '/aiqiangua-service-dispatch/getServiceList';
// 新增 - 服务清单
const api_addServiceList = baseURL + '/aiqiangua-service-dispatch/addServiceList';
// 编辑 - 服务清单
const api_editServiceList = baseURL + '/aiqiangua-service-dispatch/editServiceList';
// 服务清单下拉列表项
const api_getServiceItem = baseURL + '/aiqiangua-service-dispatch/getServiceItem';
// 详情- 服务清单
const api_getServiceDetail = baseURL + '/aiqiangua-service-dispatch/getServiceDetail';
// 下一个服务单流水号
const api_generateServiceNumber = baseURL + '/aiqiangua-service-dispatch/getNextServiceNumber';
// 删除 - 服务清单
const api_deleteServiceList = baseURL + '/aiqiangua-service-dispatch/deleteServiceList';
// 启用 - 服务清单
const api_enableServiceList = baseURL + '/aiqiangua-service-dispatch/enableServiceList';
// 禁用 - 服务清单
const api_disableServiceList = baseURL + '/aiqiangua-service-dispatch/disableServiceList';
// 列表 - 服务员工
const api_getServiceEmployeeList = baseURL + '/aiqiangua-service-dispatch/getServiceEmployeeList';
// 新增 - 服务员工
const api_addServiceEmployee = baseURL + '/aiqiangua-service-dispatch/addServiceEmployee';
// 编辑 - 服务员工
const api_editServiceEmployee = baseURL + '/aiqiangua-service-dispatch/editServiceEmployee';
// 详情 - 服务员工
const api_getServiceEmployeeDetail = baseURL + '/aiqiangua-service-dispatch/getServiceEmployeeDetail';
// 删除 - 服务员工
const api_deleteServiceEmployee = baseURL + '/aiqiangua-service-dispatch/deleteServiceEmployee';
// 按区域获取用户列表
const api_getUserListByArea = baseURL + '/aiqiangua-service-dispatch/getUserListByArea';
// 下一个派单流水号
const api_getNextDispatchNumber = baseURL + '/aiqiangua-service-dispatch/getNextDispatchNumber';
// 新增 - 服务派单
const api_addServiceDispatch = baseURL + '/aiqiangua-service-dispatch/addServiceDispatch';
// 编辑 - 服务派单
const api_editServiceDispatch = baseURL + '/aiqiangua-service-dispatch/editServiceDispatch';
// 列表 - 服务派单
const api_getServiceDispatchList = baseURL + '/aiqiangua-service-dispatch/getServiceDispatchList';
// 获取派单服务对象
const api_getServiceUser = baseURL + '/aiqiangua-service-dispatch/getServiceUser';
// 派发 - 服务派单
const api_doDispatch = baseURL + '/aiqiangua-service-dispatch/doDispatch';
// 改派 - 服务派单
const api_doDispatchAgain = baseURL + '/aiqiangua-service-dispatch/doDispatchAgain';
// 暂停 - 服务派单
const api_disableServiceDispatch = baseURL + '/aiqiangua-service-dispatch/disableServiceDispatch';
// 重启 - 服务派单
const api_enableServiceDispatch = baseURL + '/aiqiangua-service-dispatch/enableServiceDispatch';
// 取消 - 服务派单
const api_cancelServiceDispatch = baseURL + '/aiqiangua-service-dispatch/cancelServiceDispatch';
// 详情 - 服务派单
const api_getServiceDispatchDetail = baseURL + '/aiqiangua-service-dispatch/getServiceDispatchDetail';


//自定义oem接口
// const companyOemData = "http://47.97.180.115:8080/smart-care/api/sys/getOemInfoBeforeLogin.do" ;
const companyOemData = "http://47.114.74.95:8888/smart-care/api/sys/getOemInfoBeforeLogin.do"; //正式服
/*
 * 头顶header的接口
 *
 * */
//1.待办事项列表
const api_listToDoList = baseURL + '/smart-care/api/sys/listToDoList.do';
//2.新增备忘录
const api_addMemorandum = baseURL + '/smart-care/api/sys/writeMemorandum.do';
//3.机构（社区）的概况数据
const api_generalSituation = baseURL + '/smart-care/api/sys/generalSituation.do';
//4.读取备忘录
const api_getMemorandum = baseURL + '/smart-care/api/sys/getMemorandum.do';
//5.完成待办事项
const api_completeToDoList = baseURL + '/smart-care/api/sys/completeToDoList.do';
//6.定时获取未读的待办事项
const api_timingGetToDo = baseURL + '/smart-care/api/sys/timingGetToDoListNotRead.do';
/*
 * 部门管理
 * */
//1、部门管理列表接口
const api_deparment = baseURL + '/smart-care/api/sys/treeDepartment.do';
//2、删除部门接口
const api_deleteDeparment = baseURL + '/smart-care/api/sys/deleteDepartment.do';
// const api_deleteDeparment = baseUrl + '/deleteDeparment.json';
//3、修改部门信息接口
const api_editDeparment = baseURL + '/smart-care/api/sys/editDepartment.do';
// const api_editDeparment = baseUrl + '/editDeparment.json';
//4、新增部门信息接口
const api_addDeparment = baseURL + '/smart-care/api/sys/addDepartment.do';
// const api_addDeparment = baseUrl + '/addDeparment.json';
const api_getDepartmentDetail = baseURL + '/smart-care/api/sys/getDepartmentDetail.do';

/*
 * 角色管理
 * */
//1.角色列表
const api_roleList = baseURL + '/smart-care/api/sys/listRole.do';
//1.角色列表（排除超级管理员）
const api_listRoleUnlessAdmin = baseURL + '/smart-care/api/sys/listRoleUnlessAdmin.do';
// const api_roleList = baseUrl + '/roleList.json';
//2.增加角色接口
const api_addRole = baseURL + '/smart-care/api/sys/addRole.do';
// const api_addRole = baseUrl + '/addRole.json';
//3.删除角色接口
const api_deleteRole = baseURL + '/smart-care/api/sys/deleteRole.do';
// const api_deleteRole = baseUrl + '/deleteRole.json';
//4.角色授权接口
const api_roleAuth = baseURL + '/smart-care/api/sys/authorizeRole.do';
// const api_roleAuth = baseUrl + '/roleAuth.json';
//5.修改角色信息接口
const api_editRoleInfo = baseURL + '/smart-care/api/sys/editRole.do';
// const api_editRoleInfo = baseUrl + '/editRole.json';
//6.搜索角色接口
const api_searchRole = baseURL + '/smart-care/api/sys/searchRole.do';
// const api_searchRole = baseUrl + '/searchRole.json';

/*
 * 员工管理
 * */
//1、员工列表
// const api_employeeList = baseURL + '/smart-care/api/sys/listEmployee.do'
const api_employeeList = baseURL + '/smart-care/api/sys/getEmployeeList'
// const api_employeeList = baseUrl + '/employeeList.json'
//2、新增员工
const api_employeeAdd = baseURL + '/smart-care/api/sys/addEmployee.do'
// const api_employeeAdd = baseUrl + '/employeeAdd.json'
//3、修改员工资料
const api_employeeEdit = baseURL + '/smart-care/api/sys/editEmployee.do'
// const api_employeeEdit = baseUrl + '/employeeEdit.json'
//4、删除员工资料
const api_employeeDelete = baseURL + '/smart-care/api/sys/deleteEmployee.do'
// const api_employeeDelete = baseUrl + '/employeeDelete.json'
//5、重置密码
const api_employeeReset = baseURL + '/smart-care/api/sys/resetPassword.do'
// const api_employeeReset = baseUrl + '/employeeReset.json'
//6、搜索列表
const api_employeeSearch = baseURL + '/smart-care/api/sys/searchEmployee.do';
// const api_employeeSearch = baseUrl + '/employeeSearch.json';
//7、修改密码
const api_editPassword = baseURL + '/smart-care/api/sys/updatePassword.do';
//8.员工详情
const api_getEmployeeDetail = baseURL + '/smart-care/api/sys/getEmployeeDetail.do';

const getOrgAuthInfo = baseURL + '/smart-care/api/sys/getOrgAuthInfo';

/*
 * 床位管理
 * */
//1、床位管理列表接口
const api_bedList = baseURL + '/smart-care/api/sys/treeBed.do';
// const api_bedList = baseUrl + '/bedList.json';
//2、删除床位接口
const api_deleteBed = baseURL + '/smart-care/api/sys/deleteBed.do';
// const api_deleteBed = baseUrl + '/deleteBed.json';
//3、修改床位信息接口
const api_editBed = baseURL + '/smart-care/api/sys/editBed.do';
// const api_editBed = baseUrl + '/editBed.json';
//4、新增床位信息接口
const api_addBed = baseURL + '/smart-care/api/sys/addBed.do';
// const api_addBed = baseUrl + '/addBed.json';
//5、查询接口
const api_searchBed = baseUrl + '/searchBed.json';

//6、新增楼宇
const api_addBuilding = baseURL + "/smart-care/api/sys/addBuilding.do";
//7、编辑楼宇
const api_editBuilding = baseURL + '/smart-care/api/sys/editBuilding.do';

//8、新增房间
const api_addRoom = baseURL + '/smart-care/api/sys/addRoom.do';
//9、编辑房间
const api_editRoom = baseURL + '/smart-care/api/sys/editRoom.do';
//10.楼宇列表
const api_listBuilding = baseURL + '/smart-care/api/sys/listBuilding.do';
//11.删除楼层
const api_deleteFloor = baseURL + '/smart-care/api/sys/deleteFloor.do';
//12.删除房间
const api_deleteRoom = baseURL + '/smart-care/api/sys/deleteRoom.do';
//13.获取床位管理树（加上社区）
const api_treeCommunityBed = baseURL + '/smart-care/api/sys/treeCommunityBed.do';
//14.新增楼层
const api_addFloor = baseURL + '/smart-care/api/sys/addFloor.do';
//15.编辑楼层
const api_editFloor = baseURL + '/smart-care/api/sys/editFloor.do';
//16.床位详情修改
const api_getBedDetail = baseURL + '/smart-care/api/sys/getBedDetail.do';
//17.删除楼宇
const api_deleteBuilding = baseURL + '/smart-care/api/sys/deleteBuilding.do';
//18.新增社区
const api_addCommunity = baseURL + '/smart-care/api/sys/addCommunity.do';
//19.删除社区
const api_deleteCommunity = baseURL + '/smart-care/api/sys/deleteCommunity.do';
//20.编辑社区
const api_editCommunity = baseURL + '/smart-care/api/sys/editCommunity.do';
//21.社区负责人(下拉菜单)
const api_communityMenu = baseURL + "/smart-care/api/sys/listCommunityEmployee.do";

/*
  居家管理
 */
//1.获取居家房间树（加上社区）
const api_treeCommunityStreet = baseURL + "/smart-care/api/sys/treeCommunityStreet.do";
//2.新增街道
const api_addStreet = baseURL + "/smart-care/api/sys/addStreet.do";
//3.编辑街道
const api_editStreet = baseURL + "/smart-care/api/sys/editStreet.do";
//4.删除街道
const api_deleteStreet = baseURL + "/smart-care/api/sys/deleteStreet.do";
//4.街道列表
const api_listStreet = baseURL + "/smart-care/api/sys/listStreet.do";


/*
 *类型列表
 * */
//1、类型列表
const api_typeList = baseURL + '/smart-care/api/sys/listBasicTypeMenu.do';
//2、类型详情列表
const api_typeDetailList = baseURL + '/smart-care/api/sys/listBasicType.do';
//3、新增类型
const api_addType = baseURL + '/smart-care/api/sys/addBasicType.do';
//4、修改类型
const api_editType = baseURL + '/smart-care/api/sys/editBasicType.do';
//5、删除类型
const api_deleteType = baseURL + '/smart-care/api/sys/deleteBasicType.do';

/*
 *统计报表
 * */
//0.多维度的人数统计报表（五合一）
const api_calculateUser = baseURL + '/smart-care/api/sys/report/calculateUserOnVarious.do';
//1、每年男女比例统计列表
const api_reportYearList = baseURL + '/smart-care/api/sys/report/calculateUserOnGenderAndTime.do';
//2.有时间维度的慢性病人数趋势统计报表
const api_UserOnChronic = baseURL + '/smart-care/api/sys/report/calculateUserOnChronicDiseaseAndTime.do';
//2.男女比例人数统计报表
const api_calculateUserOnGender = baseURL + '/smart-care/api/sys/report/calculateUserOnGender.do';
//3.有时间维度的预警类型次数统计报表
const api_WarningOnType = baseURL + '/smart-care/api/sys/report/calculateWarningOnTypeAndTime.do';
//4.有时间维度的睡眠带数量统计报表
const api_calculateSleep = baseURL + '/smart-care/api/sys/report/calculateSleepBandOnTime.do';
const api_reportBirth = baseURL + '/smart-care/api/sys/report/calculateUserOnAge.do'
const api_reportPackage = baseURL + '/smart-care/api/sys/report/calculateUserOnHealthStatus.do'
const api_reportSick = baseURL + '/smart-care/api/sys/report/calculateUserOnChronicDisease.do';
const api_reportWarning = baseURL + '/smart-care/api/sys/report/calculateWarningOnType.do';
const api_calculateMonth = baseURL + "/smart-care/api/sys/report/calculateWarningOnTypeThisMonth.do";
const api_reportCateList = baseUrl + '/reportCateList.json';

const api_reportCateListTest = baseUrl + '/reportCateListTest.json';
const api_reportCateList1 = baseUrl + '/reportCateList1.json';
const api_reportCateList2 = baseUrl + '/reportCateList2.json';
const api_CommunityList = baseUrl + '/CommunityList.json';
const api_businessList = baseUrl + '/businessList.json';
const api_deviceState = baseURL + '/smart-care/api/sys/report/calculateSleepBandOnStatus.do';
const api_deviceStateList = baseUrl + '/deviceStateList.json';
const api_listCommunity = baseURL + '/smart-care/api/sys/listCommunity.do';
//16.各社区的年龄段人数统计报表
const api_UserOnAge = baseURL + '/smart-care/api/sys/report/calculateCommunityUserOnAge.do';
//17.各社区的慢性病人数统计报表
const api_ChronicDisease = baseURL + '/smart-care/api/sys/report/calculateCommunityUserOnChronicDisease.do';
//18.各社区的预警类型次数统计报表
const api_calculateCommunity = baseURL + '/smart-care/api/sys/report/calculateCommunityWarningOnType.do';
//19.各社区的服务套餐人数统计报表
const api_OnHealthStatus = baseURL + '/smart-care/api/sys/report/calculateCommunityUserOnHealthStatus.do';

//20.各社区的男女比例人数统计报表
const api_UserOnGender = baseURL + '/smart-care/api/sys/report/calculateCommunityUserOnGender.do';
//没有所属社区的员工列表(下拉菜单、新增社区时用)
const api_listEmployeeWithout = baseURL + '/smart-care/api/sys/listEmployeeWithoutCommunity.do';

/*
 * 设备管理
 * */
//1. 睡眠带删除设置
const api_deviceSleepDelete = baseURL + '/smart-care/api/sys/deleteSleepBand.do';
//2.睡眠带列表
const api_deviceSleepList = baseURL + '/smart-care/api/sys/listSleepBand.do';
//3.新增睡眠带
const api_addSleepBand = baseURL + '/smart-care/api/sys/addSleepBand.do';
//4.绑定床位与睡眠带
const api_bindBedAndSleepBand = baseURL + '/smart-care/api/sys/bindingBedSleepBand.do';
//5.解绑床位与睡眠带
const api_unbindBedAndSleepBand = baseURL + '/smart-care/api/sys/unbindBedSleepBand.do';
//6.获取未绑定睡眠带的床位管理树
const api_treeBedFree = baseURL + "/smart-care/api/sys/treeBedFree.do";
//7.批量导入会员
const api_importUser = baseURL + "/smart-care/api/sys/importUser";
//8.获取未绑定会员的床位管理树
const api_treeBedWithoutUser = baseURL + '/smart-care/api/sys/treeBedWithoutUser.do';
//9.获取未绑定睡眠带的床位管理树
const api_treeBedWithoutSleepBand = baseURL + '/smart-care/api/sys/treeBedWithoutSleepBand.do';
//10.未绑定床位的睡眠带列表
const api_listSleepBandWithoutBed = baseURL + '/smart-care/api/sys/listSleepBandWithoutBed.do';
//11.批量导入睡眠带
const api_importSleepBand = baseURL + '/smart-care/api/sys/importSleepBand.do';
//睡眠数据
const api_sleepData = baseURL + '/smart-care/api/sys/getSleepData.do';
const getUserSleepData = baseURL + '/smart-care/api/sys/getUserSleepData';

//获取未绑定会员的居家房间树
const api_treeHomeRoomWithoutUser = baseURL + "/smart-care/api/sys/treeHomeRoomWithoutUser.do";
//获取未绑定睡眠带的居家房间树
const api_HomeRoomWithoutSleepBand = baseURL + "/smart-care/api/sys/treeHomeRoomWithoutSleepBand.do";
//获取未直接绑定睡眠带的居家老人列表
const api_listUserNotSleepBandOwner = baseURL + "/smart-care/api/sys/listUserNotSleepBandOwner.do";
//预警功能状态修改
const api_setUserWarningFunction = baseURL + '/smart-care/api/sys/setUserWarningFunction.do';
//绑定用户腕表设备
const api_bindingWatchDevice = baseURL + '/smart-care/api/sys/bindingWatchDevice'
//设置oem
const api_getOemInfoBeforeLogin = baseURL + '/smart-care/api/sys/getOemInfoBeforeLogin.do'
/*
 * 通用设置
 * */
//1、睡眠带通用设置
// const api_sheelZoneSet = baseURL + '/smart-care/api/sys/setSleepBandGeneralThreshold.do';
// const api_sheelZoneSet = baseUrl + '/sheelZoneSet.json';
//2、自定义声音文件上传
const api_warningSound = baseUrl + '/warningSound.json';

//3.设置睡眠带通用阈值
const api_sheelZoneGeneralSet = baseURL + '/smart-care/api/sys/setSleepBandGeneralThreshold.do';


/*
 * 个性化设置列表
 * */
//1、个性化设置列表
// const api_personalSetList = baseUrl + '/personalSetList.json';
// const api_personalSetList = baseUrl + '/personalSetList.json';
// const api_personalSetList = baseUrl + '/personalSetList.json';
const api_personalSetList = baseURL + '/smart-care/api/sys/listSleepBandPersonalization.do';
//2、新增个性化列表
// const api_addPersonal = baseUrl + '/addPersonal.json';
const api_addPersonal = baseURL + '/smart-care/api/sys/setSleepBandPersonalThreshold.do';
//3、删除个性化列表
// const api_deletePersonal = baseUrl + '/deletePersonal.json';
const api_deletePersonal = baseURL + '/smart-care/api/sys/recoverSleepBandGeneralThreshold.do';
//4、修改会员个性化设置
const api_editPersonal = baseUrl + '/editPersonal.json';
// //5.睡眠带列表
// const api_sleepList = baseURL + '/smart-care/api/sys/listSleepBand.do';
//6.彈出設置姓名列表
const api_setNameList = baseURL + "/smart-care/api/sys/treeBed.do";
//7.初始化新增中的列表默认值
const api_initNewsList = baseURL + "/smart-care/api/sys/getSleepBandGeneralThreshold.do";
//8.设备管理详情按钮
const api_serviceDemandDetail = baseURL + "/smart-care/api/sys/getSleepBandDetail.do";
//9.根据mac获取当前绑定的床位号与会员
const api_getSleepBandBedAndUser = baseURL + '/smart-care/api/sys/getSleepBandBedAndUser.do'
//获取已直接绑定睡眠带的居家老人列表
const api_listUserSleepBandOwner = baseURL + '/smart-care/api/sys/listUserSleepBandOwner.do';

const api_memberList = baseURL + '/smart-care/api/sys/listUser.do';
const api_Untied = baseUrl + '/membeUntied.json';
const api_addMember = baseURL + '/smart-care/api/sys/addUser.do';
const api_deleteMember = baseURL + '/smart-care/api/sys/deleteUser.do';
const api_searchMember = baseUrl + '/searchMember.json';
const api_importExcel = baseUrl + '/importExcel.json';
const api_userDetail = baseURL + '/smart-care/api/sys/getUserDetail.do';
const api_editUserInfo = baseURL + '/smart-care/api/sys/editUser.do';
const api_checkInfo = baseURL + '/smart-care/api/sys/getUserHealthFile.do';
const api_editCheckInfo = baseURL + '/smart-care/api/sys/editUserHealthFile.do';
const api_sickList = baseURL + "/smart-care/api/sys/listChronicDisease.do"
const api_sleepBandDate = baseURL + "/smart-care/api/sys/getUserRecentSleepBandData.do";
const api_relativeList = baseURL + '/smart-care/api/sys/listUserRelatives.do'
const api_addRelative = baseURL + '/smart-care/api/sys/addRelatives.do'
const api_deleteRelative = baseURL + '/smart-care/api/sys/deleteRelatives.do'
const api_editRelative = baseURL + '/smart-care/api/sys/editRelatives.do'
const api_uploadImg = baseAPI + '/smart-care/api/sys/uploadUserImage.do';
const api_listUserWithoutBed = baseURL + '/smart-care/api/sys/listUserWithoutBed.do';
const api_listWithoutOwner = baseURL + "/smart-care/api/sys/listSleepBandWithoutOwner.do";
const api_unbindSleepBandOwner = baseURL + "/smart-care/api/sys/unbindSleepBandOwner.do";
const api_unbindSleepBand = baseURL + "/smart-care/api/sys/unbindSleepBand";
const api_bindingSleepBandOwner = baseURL + "/smart-care/api/sys/bindingSleepBandOwner.do";
const api_editQuarantineTime = baseURL + "/smart-care/api/sys/editQuarantineTime";

/*
 * 工作台
 * */
//1、会员解绑床位
const api_unbindBed = baseURL + '/smart-care/api/sys/unbindUserBed.do';
//2、会员绑定床位
const api_bindBed = baseURL + '/smart-care/api/sys/bindingUserBed.do';
//3、实时监测列表（即同时绑定了睡眠带和老人的床位列表）
const api_realTimeList = baseURL + '/smart-care/api/sys/listRealtimeMonitor.do';
//实时监测列表（居家养老模式、即绑定了睡眠带的老人列表）
const api_listHomeReal = baseURL + '/smart-care/api/sys/listHomeRealtimeMonitor.do';
//4.睡眠带预警处理列表
const api_listSleepBandWarning = baseURL + '/smart-care/api/sys/listSleepBandWarning.do';
//睡眠带预警处理列表（居家养老模式）
// const api_listHomeSleep = baseURL + '/smart-care/api/sys/listHomeSleepBandWarning.do';
const api_listHomeSleep = baseURL + '/smart-care/api/sys/getWarningList';
const api_getUserMap = baseURL + '/smart-care/api/sys/getUserMap';
const setUserMapDefaultInfo = baseURL + '/smart-care/api/sys/setUserMapDefaultInfo';

//4.某个会员的全部预警列表
const api_listUserSleep = baseURL + "/smart-care/api/sys/getWarningList";
//5.预警详情
// const api_getWarningDetail = baseURL + '/smart-care/api/sys/getWarningDetail.do';
const api_getWarningDetail = baseURL + '/smart-care/api/sys/getWarningDetail';

//6.预警处理
// const api_disposeWarning = baseURL + '/smart-care/api/sys/disposeUserWarning.do';
const api_disposeWarning = baseURL + '/smart-care/api/sys/disposeWarning';

//7.预警处理中
// const api_setWarningProcess = baseURL + '/smart-care/api/sys/setUserWarningProcessing.do';
const api_setWarningProcess = baseURL + '/smart-care/api/sys/setWarningProcessing';


//7.处理预警
const api_dealWarning = baseURL + '/smart-care/api/sys/disposeWarning.do';
//工作安排
//7.区域列表
const api_listZone = baseURL + '/smart-care/api/sys/listZone.do';
//区域列表（居家养老模式）
const api_listHomeZone = baseURL + "/smart-care/api/sys/listHomeZone.do";
//8.删除区域
const api_deleteArea = baseURL + '/smart-care/api/sys/deleteZone.do';

//删除区域（居家养老模式）
const api_deleteHomeZone = baseURL + "/smart-care/api/sys/deleteHomeZone.do";
//副本-各区域的工作安排列表（人员排班、居家模式）
const api_listHomeZoneScheduling = baseURL + "/smart-care/api/sys/listHomeZoneScheduling.do";
//修改某区域的人员排班（居家养老模式）
const api_editHomeZoneScheduling = baseURL + "/smart-care/api/sys/editHomeZoneScheduling.do";
//清除某区域的人员排班（居家养老模式）
const api_deleteHomeZoneScheduling = baseURL + "/smart-care/api/sys/deleteHomeZoneScheduling.do";


//9.新增区域
const api_addZone = baseURL + '/smart-care/api/sys/addZone.do';
//新增区域（居家养老模式）
const api_addHomeZone = baseURL + "/smart-care/api/sys/addHomeZone.do";
//10.各区域的工作安排列表（人员排班）
const api_listZoneScheduling = baseURL + '/smart-care/api/sys/listZoneScheduling.do';
//11.排班类型列表
const api_listSchedulingType = baseURL + '/smart-care/api/sys/listSchedulingType.do';
//12.编辑排班类型
const api_editSchedulingType = baseURL + '/smart-care/api/sys/editSchedulingType.do';
//13.删除排班类型
const api_deleteSchedulingType = baseURL + '/smart-care/api/sys/deleteSchedulingType.do';
//14.新增排班类型
const api_addSchedulingType = baseURL + '/smart-care/api/sys/addSchedulingType.do';
//15.工作安排列表（工作一览）
const api_listScheduling = baseURL + '/smart-care/api/sys/listScheduling.do';
//16.编辑工作安排内容
const api_editScheduling = baseURL + '/smart-care/api/sys/editScheduling.do';
//17.修改某区域的人员排班
const api_editZoneScheduling = baseURL + '/smart-care/api/sys/editZoneScheduling.do';
//18.获取房间管理树
const api_treeRoom = baseURL + '/smart-care/api/sys/treeRoom.do';
//19.工作台心率
// const api_sleepOpen = baseURL + '/smart-care/api/sys/openSleepOnline.do';
//20.复制某区域的人员排班
const api_copyZoneScheduling = baseURL + '/smart-care/api/sys/copyZoneScheduling.do';
//21.服务类型列表
const api_listServiceType = baseURL + '/smart-care/api/sys/listServiceType.do';
//楼层列表
const api_listFloor = baseURL + '/smart-care/api/sys/listFloor.do';
//22.各班次的工作安排列表（快速查看排班）
const api_quickGetScheduling = baseURL + '/smart-care/api/sys/quickGetScheduling.do';
//23.打开波形图数据传输开关
const api_setSleepOnline = baseURL + '/smart-care/api/sys/setSleepOnline.do';
//25.清除某区域的人员排班
const api_deleteZoneScheduling = baseURL + '/smart-care/api/sys/deleteZoneScheduling.do';
//26.编辑区域
const api_editZone = baseURL + '/smart-care/api/sys/editZone.do';
//编辑区域（居家养老模式）
const api_editHomeZone = baseURL + '/smart-care/api/sys/editHomeZone.do';
const api_listRoom = baseURL + '/smart-care/api/sys/listRoom.do';
const api_listBed = baseURL + '/smart-care/api/sys/listBed.do';
const api_withoutZone = baseURL + '/smart-care/api/sys/listNursingEmployeeWithoutZone.do';
const api_copyHomeZoneScheduling = baseURL + '/smart-care/api/sys/copyHomeZoneScheduling.do';
const api_NotDisposed = baseURL + '/smart-care/api/sys/getWarningNotDisposed';
const api_listWarningNotice = baseURL + '/smart-care/api/sys/getWarningNotice';
//报警声音控制
const setSoundEnable = baseURL + '/smart-care/api/sys/setSoundEnable';
// 授权角色
const api_authorizeRole = baseURL + "/smart-care/api/sys/authorizeRole.do";
//切换养老模式
const api_setPensionMode = baseURL + "/smart-care/api/sys/setPensionMode.do";
//获取全部菜单,两种切换模式
const api_listAllMenu = baseURL + "/smart-care/api/sys/listmenu";
// 退出登录
const api_logout = baseURL + "/smart-care/api/sys/logout.do";



// --------腕表集成[机构组织管理]----------
// 组织架构树
const api_getOrgTree = baseURL + "/smart-care/api/sys/getOrgTree";
// 二级子机构列表
const api_getCommunityList = baseURL + "/smart-care/api/sys/getCommunityList";
// 部门列表
const api_getDepartmentList = baseURL + "/smart-care/api/sys/getDepartmentList";
// 下级部门列表
const api_getSubDepartmentList = baseURL + "/smart-care/api/sys/getSubDepartmentList";
// 除超管外的员工列表（下拉列表项）
const api_getEmployeeExceptSuperAdmin = baseURL + "/smart-care/api/sys/getEmployeeExceptSuperAdmin";
// 新增二级机构
const api_AddCommunity = baseURL + "/smart-care/api/sys/AddCommunity";
// 编辑二级机构
const api_EditCommunity = baseURL + "/smart-care/api/sys/editCommunity";
// 删除二级机构
const api_DeleteCommunity = baseURL + "/smart-care/api/sys/deleteCommunity";
// 编辑部门
const api_editDepartment = baseURL + "/smart-care/api/sys/editDepartment";
// 新增部门
const api_addDepartment = baseURL + "/smart-care/api/sys/addDepartment";
// 删除部门
const api_deleteDepartment = baseURL + "/smart-care/api/sys/deleteDepartment";
// 三级子机构列表
const api_getSubList = baseURL + "/smart-care/api/sys/getSubList";
// 新增三级子机构
const api_addSub = baseURL + "/smart-care/api/sys/addSub";
// 删除三级子机构
const api_deleteSub = baseURL + "/smart-care/api/sys/deleteSub";
// 编辑三级子机构
const api_editSub = baseURL + "/smart-care/api/sys/editSub";
// 新增子部门
const api_addSubDepartment = baseURL + "/smart-care/api/sys/addSubDepartment";
// 获取硬件帐号信息
const api_getDeviceAccount = baseURL + "/smart-care/api/sys/getDeviceAccount";
// 关联硬件帐号
const api_setDeviceAccount = baseURL + "/smart-care/api/sys/setDeviceAccount";
// 角色列表
const api_getRoleList = baseURL + "/smart-care/api/sys/getRoleList";
// 角色详情
const api_getRoleDetail = baseURL + "/smart-care/api/sys/getRoleDetail";
// 一级机构列表（下拉列表项）
const api_getOrganizationItem = baseURL + "/smart-care/api/sys/getOrganizationItem";
// 二级机构列表（下拉列表项）
const api_getCommunityItem = baseURL + "/smart-care/api/sys/getCommunityItem";
// 三级机构列表（下拉列表项）
const api_getSubItem = baseURL + "/smart-care/api/sys/getSubItem";
// 新增角色
const api_AddRole = baseURL + "/smart-care/api/sys/addRole";
// 编辑角色
const api_editRole = baseURL + "/smart-care/api/sys/editRole";
// 删除角色
const api_DeleteRole = baseURL + "/smart-care/api/sys/deleteRole";
// 角色列表（下拉列表项）
const api_getRoleItem = baseURL + "/smart-care/api/sys/getRoleItem";
const api_getEmployeeList = baseURL + "/smart-care/api/sys/getEmployeeList";
const api_GetEmployeeDetail = baseURL + "/smart-care/api/sys/getEmployeeDetail";
const api_addEmployee = baseURL + "/smart-care/api/sys/addEmployee";
const api_editEmployee = baseURL + "/smart-care/api/sys/editEmployee";
const api_deleteEmployee = baseURL + "/smart-care/api/sys/deleteEmployee";
const api_listUser = baseURL + "/smart-care/api/sys/listUser.do";
const api_getLngLat = baseURL + "/smart-care/api/sys/getLngLat";
const api_correctHomeLocation = baseURL + "/smart-care/api/sys/correctHomeLocation";
const api_getUserBasicInfo = baseURL + "/smart-care/api/sys/getUserBasicInfo";
const api_editUser = baseURL + "/smart-care/api/sys/editUser.do";
const api_getGuardianList = baseURL + "/smart-care/api/sys/getGuardianList";
const api_addGuardian = baseURL + "/smart-care/api/sys/addGuardian";
const api_getGuardianDetail = baseURL + "/smart-care/api/sys/getGuardianDetail";
const api_editGuardian = baseURL + "/smart-care/api/sys/editGuardian";
const api_deleteGuardian = baseURL + "/smart-care/api/sys/deleteGuardian";
const api_getDeviceList = baseURL + "/smart-care/api/sys/getDeviceList";
const getNotifyDeviceList = baseURL + "/smart-care/api/sys/getNotifyDeviceList";
const exportDeviceList= baseURL + "/smart-care/api/sys/exportDeviceListByAjax";
const exportDeviceSosNumbers= baseURL + "/smart-care/api/sys/exportDeviceSosNumbers";
const api_addDevice = baseURL + "/smart-care/api/sys/addDevice";
//紧急联系人sos修改
const getDeviceGeneralConfig = baseURL + "/smart-care/api/sys/getDeviceGeneralConfig";
const setDeviceGeneralConfig = baseURL + "/smart-care/api/sys/setDeviceGeneralConfig";

const api_deleteDevice = baseURL + "/smart-care/api/sys/deleteDevice";
const api_syncDevice = baseURL + "/smart-care/api/sys/syncDevice";
const api_unbindDeviceFromApp = baseURL + "/smart-care/api/sys/unbindDeviceFromApp";
const api_bindingDevice = baseURL + "/smart-care/api/sys/bindingDevice";
const api_unbindingDevice = baseURL + "/smart-care/api/sys/unbindingDevice";
const api_getDeviceLocationData = baseURL + "/smart-care/api/sys/getDeviceLocationData";
const api_realtimeLocation = baseURL + "/smart-care/api/sys/realtimeLocation";
const api_getDeviceConfiguration = baseURL + "/smart-care/api/sys/getDeviceConfiguration";
const api_restartDevice = baseURL + "/smart-care/api/sys/restartDevice";
const api_getDeviceImeiCode = baseURL + "/smart-care/api/sys/getDeviceImeiCode";
const api_getSOSNumber = baseURL + "/smart-care/api/sys/getSOSNumber";
const api_editSOSNumber = baseURL + "/smart-care/api/sys/editSOSNumber";
const api_deleteSOSNumber = baseURL + "/smart-care/api/sys/deleteSOSNumber";
const api_editDeviceConfigure = baseURL + "/smart-care/api/sys/editDeviceConfigure";

const getRelationAlarmDeviceList = baseURL + "/smart-care/api/nursingHome/getRelationAlarmDeviceList";
const nurgetNotifyDeviceList = baseURL + "/smart-care/api/nursingHome/getNotifyDeviceList";
const bindingAlarmDevice = baseURL + "/smart-care/api/nursingHome/bindingAlarmDevice";
const unbindingAlarmDevice = baseURL + "/smart-care/api/nursingHome/unbindingAlarmDevice";
const editAlarmText = baseURL + "/smart-care/api/nursingHome/editAlarmText";

const api_getDeviceAlertData = baseURL + "/smart-care/api/sys/getDeviceAlertData";
const api_editDeviceAlert = baseURL + "/smart-care/api/sys/editDeviceAlert";
const api_deleteDeviceAlert = baseURL + "/smart-care/api/sys/deleteDeviceAlert";
const api_editDeviceGrade = baseURL + "/smart-care/api/sys/editDeviceGrade";
const editHomeDeviceGrade = baseURL + "/smart-care/api/sys/editHomeDeviceGrade";
const api_deleteFence = baseURL + "/smart-care/api/sys/deleteFence";
const api_getDeviceHeartrate = baseURL + "/smart-care/api/sys/getDeviceHeartrate";
const api_getDeviceMentalStress = baseURL + "/smart-care/api/sys/getDeviceMentalStress";
const api_getDeviceExerciseHeartrate = baseURL + "/smart-care/api/sys/getDeviceExerciseHeartrate";
const api_nearbyWifi = baseURL + "/smart-care/api/sys/nearbyWifi";
const api_getDeviceBloodpressure = baseURL + "/smart-care/api/sys/getDeviceBloodpressure";
const api_getDeviceBloodoxygene = baseURL + "/smart-care/api/sys/getDeviceBloodoxygene";
const api_getDeviceSleep = baseURL + "/smart-care/api/sys/getDeviceSleep";
const api_getDevicePedometer = baseURL + "/smart-care/api/sys/getDevicePedometer";
const api_connectingWifi = baseURL + "/smart-care/api/sys/connectingWifi";
const api_get4gDeviceSleep = baseURL + "/smart-care/api/sys/get4gDeviceSleep";
const api_get4gDevicePedometer = baseURL + "/smart-care/api/sys/get4gDevicePedometer";
const api_getDeviceAbnormalData = baseURL + "/smart-care/api/sys/getDeviceAbnormalData";
const api_getHypertensionList = baseURL + "/smart-care/api/sys/getHypertensionList";
const api_monitor = baseURL + "/smart-care/statistics/monitor";
const api_warning = baseURL + "/smart-care/statistics/warning";
const api_analysis = baseURL + "/smart-care/statistics/analysis";
const api_getDeviceWithoutOwner = baseURL + "/smart-care/api/sys/getDeviceWithoutOwner";
const api_getExistWatchDeviceType = baseURL + "/smart-care/api/sys/getExistWatchDeviceType";
const api_getExistBpDeviceType = baseURL + "/smart-care/api/sys/getExistBpDeviceType";
const api_getExistHomeDeviceType = baseURL + "/smart-care/api/sys/getExistHomeDeviceType";
const api_getUserBindingDeviceList = baseURL + "/smart-care/api/sys/getUserBindingDeviceList";
const api_getBindingUserList = baseURL + "/smart-care/api/sys/getBindingUserList";
const api_unbindingHomeDevice = baseURL + "/smart-care/api/sys/unbindingHomeDevice";
//未绑定用户的腕表列表
const api_getWatchDeviceWithoutOwner = baseURL + "/smart-care/api/sys/getWatchDeviceWithoutOwner"
//未绑定用户的血压计列表
const api_getBpDeviceWithoutOwner = baseURL + "/smart-care/api/sys/getBpDeviceWithoutOwner"
//未绑定用户的睡眠带列表
const api_getSleepBandWithoutOwner = baseURL + "/smart-care/api/sys/getSleepBandWithoutOwner"
//未绑定居家设备列表
const api_getHomeDeviceWithoutOwner = baseURL + '/smart-care/api/sys/getHomeDeviceWithoutOwner'
//绑定血压计
const api_bindingBpDevice = baseURL + '/smart-care/api/sys/bindingBpDevice'
//绑定睡眠带
const api_bindingSleepBand = baseURL + '/smart-care/api/sys/bindingSleepBand'
//画电子围栏
const api_drawFence = baseURL + '/smart-care/api/sys/drawFence'
//清除电子围栏
const api_clearFence = baseURL + '/smart-care/api/sys/delfence'
//大屏数据展示
//当日预警分布
const api_InformationShow_warningrange = baseURL + '/smart-care/bigscreen/warningrange'
//当日最新N条预警
const api_InformationShow_warninglist = baseURL + '/smart-care/bigscreen/warninglist'
//用户位置信息
const api_InformationShow_userlocation = baseURL + '/smart-care/bigscreen/userlocation'
//预警总数和用户总数
const api_InformationShow_warningtotal = baseURL + '/smart-care/bigscreen/warningtotal'
//最近N天的派单总数
const api_InformationShow_servicecount = baseURL + '/smart-care/bigscreen/servicecount'
//用户健康状态
const api_InformationShow_healthstatus = baseURL + '/smart-care/bigscreen/healthstatus'
//用户年龄分布
const api_InformationShow_agerange = baseURL + '/smart-care/bigscreen/agerange'
const api_addHomeWifi = baseURL + '/smart-care/api/sys/addHomeWifi'
const api_updateUserHealthFile = baseURL + '/smart-care/api/sys/updateUserHealthFile'
const api_getUserHealthFile = baseURL + '/smart-care/api/sys/getUserHealthFile'
const api_getAllergicHistoryList = baseURL + '/smart-care/api/sys/getAllergicHistoryList'
const api_addAllergicHistory = baseURL + '/smart-care/api/sys/addAllergicHistory'
const api_deleteAllergicHistory = baseURL + '/smart-care/api/sys/deleteAllergicHistory'
const api_editFamilyHistory = baseURL + '/smart-care/api/sys/editFamilyHistory'
const api_deleteFamilyHistory = baseURL + '/smart-care/api/sys/deleteFamilyHistory'
const api_addFamilyHistory = baseURL + '/smart-care/api/sys/addFamilyHistory'
const api_getFamilyHistoryList = baseURL + '/smart-care/api/sys/getFamilyHistoryList'
const api_editGeneticDisease = baseURL + '/smart-care/api/sys/editGeneticDisease'
const api_addGeneticDisease = baseURL + '/smart-care/api/sys/addGeneticDisease'
const api_deleteGeneticDisease = baseURL + '/smart-care/api/sys/deleteGeneticDisease'
const api_getGeneticDiseaseList = baseURL + '/smart-care/api/sys/getGeneticDiseaseList'
const api_editAllergicHistory = baseURL + '/smart-care/api/sys/editAllergicHistory'
const api_getUserBloodpressure = baseURL + '/smart-care/api/sys/getUserBloodpressure'
const api_getUserTemperature = baseURL + '/smart-care/api/sys/getUserTemperature'
const api_getUserHeartrate = baseURL + '/smart-care/api/sys/getUserHeartrate'
const exportUser= baseURL + '/smart-care/api/sys/exportUser'
//发病记录
const api_getUserOnsetRecordList = baseURL + '/smart-care/api/sys/getUserOnsetRecordList'
//用药记录
const api_getUserMedicationRecordList = baseURL + '/smart-care/api/sys/getUserMedicationRecordList'
//手术记录列表
const api_getUserSurgicalTraumaRecordList = baseURL + '/smart-care/api/sys/getUserSurgicalTraumaRecordList'
const api_addUserOnsetRecord = baseURL + '/smart-care/api/sys/addUserOnsetRecord'
const api_addUserIsolateRecord = baseURL + '/smart-care/api/sys/addUserIsolateRecord'
const api_getUserIsolateRecordList = baseURL + '/smart-care/api/sys/getUserIsolateRecordList'
const api_deleteUserIsolateRecord = baseURL + '/smart-care/api/sys/deleteUserIsolateRecord'
const api_editUserIsolateRecord = baseURL + '/smart-care/api/sys/editUserIsolateRecord'
const api_editUserMedicationRecord = baseURL + '/smart-care/api/sys/editUserMedicationRecord'
const api_addUserMedicationRecord = baseURL + '/smart-care/api/sys/addUserMedicationRecord'
const api_deleteUserMedicationRecord = baseURL + '/smart-care/api/sys/deleteUserMedicationRecord'
const api_editUserOnsetRecord = baseURL + '/smart-care/api/sys/editUserOnsetRecord'
const api_deleteUserOnsetRecord = baseURL + '/smart-care/api/sys/deleteUserOnsetRecord'
const api_deleteUserSurgicalTraumaRecord = baseURL + '/smart-care/api/sys/deleteUserSurgicalTraumaRecord'
const api_editUserSurgicalTraumaRecord = baseURL + '/smart-care/api/sys/editUserSurgicalTraumaRecord'
const api_addUserSurgicalTraumaRecord = baseURL + '/smart-care/api/sys/addUserSurgicalTraumaRecord'
const api_updateBasicUserInfo = baseURL + '/smart-care/api/sys/updateBasicUserInfo'
const api_reportUserHealthData = baseURL + '/smart-care/api/sys/reportUserHealthData'
const api_getLabelList = baseURL + '/smart-care/api/sys/getLabelList'
const api_unbindLabel = baseURL + '/smart-care/api/sys/unbindLabel'
const api_editLabel = baseURL + '/smart-care/api/sys/editLabel'
const api_getLabelDetail = baseURL + '/smart-care/api/sys/getLabelDetail'
const api_getHomeLocationData = baseURL + '/smart-care/api/sys/getHomeLocationData'
const api_getDeviceTemperature = baseURL + '/smart-care/api/sys/getDeviceTemperature'
const api_importDevice = baseURL + '/smart-care/api/sys/importDevice'
const importOrgData = baseURL + '/smart-care/api/sys/importOrgData'
const api_importHomeDevice = baseURL + '/smart-care/api/sys/importHomeDevice'
const api_importHomeUser = baseURL + '/smart-care/api/sys/importHomeUser.do'
const api_editS6TConfigure = baseURL + '/smart-care/api/sys/editS6TConfigure'
const api_unbindingBpDevice = baseURL + '/smart-care/api/sys/unbindingBpDevice'
const api_getQRCodeInfo = baseURL + '/smart-care/api/sys/getQRCodeInfo'
const api_editQRCodeInfo = baseURL + '/smart-care/api/sys/editQRCodeInfo'
//设备批量导入
const api_importDeviceAll = baseURL + '/smart-care/api/sys/importDevice'
const api_getUserListByGrade = baseURL + '/aiqiangua-service-dispatch/getUserListByGrade'
const api_getServiceDispatchEmployeeList = baseURL + '/aiqiangua-service-dispatch/getServiceDispatchEmployeeList'
const api_editHomeDeviceAlarmTime = baseURL + '/smart-care/api/sys/editHomeDeviceAlarmTime'
const api_allmenu = baseURL + '/smart-care/api/sys/allmenu'
// 5.8最近一个月新增异常信息
const api_increaseTrend = baseURL + '/smart-care/statistics/epidemic/increaseTrend';
const api_increaseAbnormal = baseURL + '/smart-care/statistics/epidemic/increaseAbnormal';
// 5.9最近一个月累计异常信息
const api_cumulativeTrend = baseURL + '/smart-care/statistics/epidemic/cumulativeTrend';
const api_gradeRank = baseURL + '/smart-care/statistics/epidemic/gradeRank'
const api_range = baseURL + '/smart-care/statistics/epidemic/abnormalRange'
const api_sexRange = baseURL + '/smart-care/statistics/epidemic/sexRange'
const api_healthPopulation = baseURL + '/smart-care/statistics/epidemic/healthPopulation'
const api_temperatureAbnormaCount = baseURL + '/smart-care/statistics/epidemic/temperatureAbnormaCount'
const api_restoreDevice = baseURL + '/smart-care/api/sys/restoreDevice'
const api_broadcast = baseURL + '/smart-care/api/sys/broadcast'
const api_listBroadcast = baseURL + '/smart-care/api/sys/listBroadcast'
const api_editDeviceFences = baseURL + '/smart-care/api/sys/editDeviceFences'
const api_getTerminalList = baseURL + '/smart-care/api/sys/getTerminalList'
const api_unbindingTerminal = baseURL + '/smart-care/api/sys/unbindingTerminal'
const api_editTerminalMark = baseURL + '/smart-care/api/sys/editTerminalMark'
const api_customerRegister = baseURL + '/smart-care/manage/org/customerRegister'
const sendCaptcha = baseURL + '/smart-care/api/sys/sendCaptcha'
// in7/17
const getDeviceCallRecordList = baseURL + '/smart-care/api/sys/getDeviceCallRecordList' // 通话记录

const getOperationLogList = baseURL + '/smart-care/api/sys/getOperationLogList' // 操作日志

const exportWarningList = baseURL + '/smart-care/api/sys/exportWarningList' // 操作日志

const ha11Action = baseURL + '/smart-care/api/sys/ha11Action' // 操作日志
const editHa11Configuration = baseURL + '/smart-care/api/sys/editHa11Configuration' // 操作日志
const ha11DealFall = baseURL + '/smart-care/api/sys/ha11DealFall' // 操作日志

const getQingLanToken = baseURL + '/smart-care/api/sys/getQingLanToken'

const radarSettingLocation = baseURL + '/smart-care/api/sys/radarSettingLocation'
export {
  ha11Action,
  editHa11Configuration,
  ha11DealFall,
  api_customerRegister,
  sendCaptcha,
  api_unbindingTerminal,
  api_editTerminalMark,
  api_getTerminalList,
  getDeviceCallRecordList,
  api_getOemInfoBeforeLogin,
  api_editDeviceFences,
  api_listBroadcast,
  api_broadcast,
  api_restoreDevice,
  api_allmenu,
  api_getUserMap,
  setUserMapDefaultInfo,
  api_importDeviceAll,
  api_getServiceDispatchEmployeeList,
  api_getUserListByGrade,
  api_editHomeDeviceAlarmTime,
  api_unbindSleepBand,
  api_unbindingBpDevice,
  api_editQRCodeInfo,
  api_getQRCodeInfo,
  api_updateBasicUserInfo,
  api_increaseAbnormal,
  api_temperatureAbnormaCount,
  api_healthPopulation,
  api_sexRange,
  api_range,
  api_gradeRank,
  api_increaseTrend,
  api_cumulativeTrend,
  api_editS6TConfigure,
  api_importHomeUser,
  api_importHomeDevice,
  api_importDevice,
  importOrgData,
  api_get4gDevicePedometer,
  api_getDeviceTemperature,
  api_getHomeLocationData,
  api_correctHomeLocation,
  api_getLabelList,
  api_unbindLabel,
  api_editLabel,
  api_getLabelDetail,
  api_reportUserHealthData,
  api_addUserOnsetRecord,
  api_addUserIsolateRecord,
  api_getUserIsolateRecordList,
  api_deleteUserIsolateRecord,
  api_editUserIsolateRecord,
  api_editUserMedicationRecord,
  api_addUserMedicationRecord,
  api_deleteUserMedicationRecord,
  api_editUserOnsetRecord,
  api_deleteUserOnsetRecord,
  api_deleteUserSurgicalTraumaRecord,
  api_editUserSurgicalTraumaRecord,
  api_addUserSurgicalTraumaRecord,
  api_getUserSurgicalTraumaRecordList,
  api_getUserMedicationRecordList,
  api_getUserOnsetRecordList,
  api_getUserHeartrate,
  exportUser,
  api_getUserTemperature,
  api_getUserBloodpressure,
  api_editAllergicHistory,
  api_getGeneticDiseaseList,
  api_addGeneticDisease,
  api_deleteGeneticDisease,
  api_editGeneticDisease,
  api_getFamilyHistoryList,
  api_deleteFamilyHistory,
  api_addFamilyHistory,
  api_editFamilyHistory,
  api_deleteAllergicHistory,
  api_addAllergicHistory,
  api_getAllergicHistoryList,
  api_getUserHealthFile,
  api_updateUserHealthFile,
  api_addHomeWifi,
  api_editQuarantineTime,
  api_deleteDeviceAlert,
  api_InformationShow_userlocation,
  api_InformationShow_warningtotal,
  api_InformationShow_servicecount,
  api_InformationShow_healthstatus,
  api_InformationShow_agerange,
  api_InformationShow_warningrange,
  api_InformationShow_warninglist,
  api_clearFence,
  api_drawFence,
  api_bindingSleepBand,
  api_getHomeDeviceWithoutOwner,
  api_bindingBpDevice,
  api_getSleepBandWithoutOwner,
  api_getBpDeviceWithoutOwner,
  api_getWatchDeviceWithoutOwner,
  api_bindingWatchDevice,
  api_getExistBpDeviceType,
  api_getExistHomeDeviceType,
  api_getUserBindingDeviceList,
  api_getBindingUserList,
  api_unbindingHomeDevice,
  api_getOrgTree,
  api_getCommunityList,
  api_getDepartmentList,
  api_getSubDepartmentList,
  api_getEmployeeExceptSuperAdmin,
  api_AddCommunity,
  api_EditCommunity,
  api_DeleteCommunity,
  api_editDepartment,
  api_addDepartment,
  api_getSubList,
  api_addSub,
  api_deleteSub,
  api_editSub,
  api_deleteDepartment,
  api_addSubDepartment,
  api_getRoleList,
  api_getRoleDetail,
  api_getOrganizationItem,
  api_getCommunityItem,
  api_getSubItem,
  api_AddRole,
  api_editRole,
  api_DeleteRole,
  api_getEmployeeList,
  api_GetEmployeeDetail,
  getOrgAuthInfo,
  api_addEmployee,
  api_editEmployee,
  api_deleteEmployee,
  api_getRoleItem,
  api_getLngLat,
  api_getUserBasicInfo,
  api_editUser,
  api_getGuardianList,
  api_addGuardian,
  api_getGuardianDetail,
  api_editGuardian,
  api_deleteGuardian,
  api_getDeviceList,
  getNotifyDeviceList,
  exportDeviceList,
  exportDeviceSosNumbers,
  api_addDevice,
  getDeviceGeneralConfig,
  setDeviceGeneralConfig,
  api_getDeviceAccount,
  api_setDeviceAccount,
  api_syncDevice,
  api_unbindDeviceFromApp,
  api_bindingDevice,
  api_unbindingDevice,
  api_getDeviceLocationData,
  api_realtimeLocation,
  api_getDeviceConfiguration,
  api_restartDevice,
  api_getDeviceImeiCode,
  api_getSOSNumber,
  api_editSOSNumber,
  api_deleteSOSNumber,
  api_editDeviceConfigure,
  
  getRelationAlarmDeviceList,
  nurgetNotifyDeviceList, 
  bindingAlarmDevice,
  unbindingAlarmDevice,
  editAlarmText,
  
  api_getDeviceAlertData,
  api_editDeviceAlert,
  api_deleteDevice,
  api_editDeviceGrade,
  editHomeDeviceGrade,
  api_deleteFence,
  api_getDeviceHeartrate,
  api_getDeviceMentalStress,
  api_getDeviceExerciseHeartrate,
  api_nearbyWifi,
  api_getDeviceBloodpressure,
  api_getDeviceBloodoxygene,
  api_getDeviceSleep,
  api_getDevicePedometer,
  api_connectingWifi,
  api_get4gDeviceSleep,
  api_getDeviceAbnormalData,
  api_getHypertensionList,
  api_analysis,
  api_monitor,
  api_warning,
  api_getDeviceWithoutOwner,
  api_getExistWatchDeviceType,
  companyOemData,
  api_listToDoList,
  api_addMemorandum,
  api_generalSituation,
  api_getMemorandum,
  api_completeToDoList,
  api_timingGetToDo,
  api_auth,
  api_deparment,
  api_deleteDeparment,
  api_editDeparment,
  api_addDeparment,
  api_getDepartmentDetail,
  api_roleList,
  api_listRoleUnlessAdmin,
  api_addRole,
  api_deleteRole,
  api_roleAuth,
  api_editRoleInfo,
  api_searchRole,
  api_deviceSleepDelete,
  api_deviceSleepList,
  api_addSleepBand,
  api_bindBedAndSleepBand,
  api_unbindBedAndSleepBand,
  api_treeBedFree,
  api_serviceDemandDetail,
  api_importUser,
  api_getSleepBandBedAndUser,
  api_listUserSleepBandOwner,
  api_treeBedWithoutUser,
  api_treeBedWithoutSleepBand,
  api_listSleepBandWithoutBed,
  api_importSleepBand,
  api_sleepData,
  getUserSleepData,
  api_treeHomeRoomWithoutUser,
  api_HomeRoomWithoutSleepBand,
  api_listUserNotSleepBandOwner,
  api_setUserWarningFunction,
  api_employeeList,
  api_employeeAdd,
  api_employeeEdit,
  api_employeeDelete,
  api_employeeReset,
  api_employeeSearch,
  api_bedList,
  api_deleteBed,
  api_editBed,
  api_addBed,
  api_searchBed,
  api_addBuilding,
  api_editBuilding,
  api_addRoom,
  api_editRoom,
  api_listBuilding,
  api_deleteFloor,
  api_deleteRoom,
  api_treeCommunityBed,
  api_addFloor,
  api_editFloor,
  api_getBedDetail,
  api_deleteBuilding,
  api_addCommunity,
  api_deleteCommunity,
  api_editCommunity,
  api_communityMenu,
  api_treeCommunityStreet,
  api_addStreet,
  api_editStreet,
  api_deleteStreet,
  api_listStreet,
  api_addType,
  api_editType,
  api_deleteType,
  api_typeList,
  api_typeDetailList,
  api_reportYearList,
  api_UserOnChronic,
  api_calculateUserOnGender,
  api_WarningOnType,
  api_calculateSleep,
  api_calculateUser,
  api_reportBirth,
  api_reportPackage,
  api_reportSick,
  api_reportWarning,
  api_calculateMonth,
  api_reportCateList,
  api_reportCateListTest,
  api_reportCateList1,
  api_reportCateList2,
  api_businessList,
  api_CommunityList,
  api_deviceState,
  api_deviceStateList,
  api_listCommunity,
  api_UserOnAge,
  api_ChronicDisease,
  api_calculateCommunity,
  api_OnHealthStatus,
  api_UserOnGender,
  api_listEmployeeWithout,
  api_warningSound,
  api_sheelZoneGeneralSet,
  api_personalSetList,
  api_addPersonal,
  api_deletePersonal,
  api_editPersonal,
  api_editPassword,
  api_getEmployeeDetail,
  api_memberList,
  api_Untied,
  api_addMember,
  api_deleteMember,
  api_searchMember,
  api_importExcel,
  api_userDetail,
  api_setNameList,
  api_initNewsList,
  api_editUserInfo,
  api_checkInfo,
  api_editCheckInfo,
  api_sickList,
  api_unbindBed,
  api_bindBed,
  api_sleepBandDate,
  api_listSleepBandWarning,
  api_listHomeSleep,
  api_listUserSleep,
  api_getWarningDetail,
  api_disposeWarning,
  api_setWarningProcess,
  api_dealWarning,
  api_listZone,
  api_listHomeZone,
  api_deleteArea,
  api_deleteHomeZone,
  api_listHomeZoneScheduling,
  api_editHomeZoneScheduling,
  api_deleteHomeZoneScheduling,
  api_addZone,
  api_addHomeZone,
  api_listScheduling,
  api_listZoneScheduling,
  api_listSchedulingType,
  api_editSchedulingType,
  api_deleteSchedulingType,
  api_addSchedulingType,
  api_editScheduling,
  api_editZoneScheduling,
  api_treeRoom,
  api_copyZoneScheduling,
  api_listServiceType,
  api_listFloor,
  api_quickGetScheduling,
  api_setSleepOnline,
  api_deleteZoneScheduling,
  api_editZone,
  api_editHomeZone,
  api_listRoom,
  api_listBed,
  api_withoutZone,
  api_copyHomeZoneScheduling,
  api_relativeList,
  api_addRelative,
  api_deleteRelative,
  api_editRelative,
  api_uploadImg,
  api_listUserWithoutBed,
  api_listWithoutOwner,
  api_unbindSleepBandOwner,
  api_bindingSleepBandOwner,
  api_realTimeList,
  api_listHomeReal,

  api_NotDisposed,
  api_listWarningNotice,
  setSoundEnable,
  api_authorizeRole,
  api_setPensionMode,
  api_listAllMenu,
  api_logout,
  api_getAreaTypeTree,
  api_addAreaType,
  api_getAreaTypeList,
  api_deleteAreaType,
  api_editAreaType,
  api_getRealtimeMonitorList,
  api_addHouse,
  api_getRealtimeMonitorDetail,
  api_editHouse,
  api_deleteHouse,
  api_changeHouseAreaType,
  api_addHomeDevice,
  api_listHomeDevice,
  api_listHouse,
  api_bindingHomeDevice,
  api_unbindHomeDevice,
  api_setHomeDeviceWarning,
  setDeviceWarningFunction,
  syncWarningUser,
  api_getHomeDeviceDetail,
  api_editHA03WarningSetting,
  editHA05WarningSetting,
  editHomeDeviceSosContact,
  editTerminalWarningSetting,
  editTerminalInfraredSetting,
  editHomeDevice,
  api_listDoorStatusData,
  api_listUser,
  api_bindingUserHouse,
  api_unbindUserHouse,
  api_getSleepBandDetail,
  api_deleteHomeDevice,
  api_getSimpleAreaTypeList,
  api_importHomeSleepBand,
  api_getServiceTypeList,
  api_editServiceType,
  api_addServiceType,
  api_deleteServiceType,
  api_getServiceOrganizationList,
  api_addServiceOrganization,
  api_editServiceOrganization,
  api_deleteServiceOrganization,
  api_getServiceOrganizationItem,
  api_getServiceList,
  api_addServiceList,
  api_getServiceTypeItem,
  api_generateServiceNumber,
  api_deleteServiceList,
  api_enableServiceList,
  api_disableServiceList,
  api_editServiceList,
  api_getServiceEmployeeList,
  api_addServiceEmployee,
  api_editServiceEmployee,
  api_getServiceEmployeeDetail,
  api_deleteServiceEmployee,
  api_getServiceItem,
  api_getServiceDetail,
  api_getUserListByArea,
  api_getNextDispatchNumber,
  api_addServiceDispatch,
  api_getServiceDispatchList,
  api_getServiceUser,
  api_doDispatch,
  api_doDispatchAgain,
  api_disableServiceDispatch,
  api_enableServiceDispatch,
  api_cancelServiceDispatch,
  api_getServiceDispatchDetail,
  api_editServiceDispatch,
  api_editHomeDeviceInfrared,
  getOperationLogList,
  exportWarningList,
  getQingLanToken,
  radarSettingLocation,
}



// WEBPACK FOOTER //
// ./src/api/api.js